<template>
  <div class="my-licence">
    <div class="account-card">
      <div class="account-card-header">
        <h4 class="account-card-title">未完成发货说明</h4>
      </div>
      <div class="page-manage page-manage-evaluation-config">
        <customize-form
          :form-config="formConfig"
          @on-query="onQuery"
          @on-reset="onReset"
        ></customize-form>
        <customize-table
          :table-config="tableConfig"
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :currentPage.sync="params.pageIndex"
        >
          <template v-slot:noticeTitle="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span
                  class="cell-link"
                  @click="onCheckBidFile(scope.row.noticeId)"
                  >{{ scope.row.noticeTitle }}</span
                >
              </template>
            </el-table-column>
          </template>
          <template v-slot:statusCode="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span>{{
                  scope.row.statusCode == 0
                    ? '待执行'
                    : scope.row.statusCode == 1
                    ? '执行中'
                    : scope.row.statusCode == 2
                    ? '执行完成'
                    : ''
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:controls="{ column }">
            <el-table-column v-bind="column" fixed="right">
              <template v-slot="scope">
                <span
                  class="cell-link"
                  @click="onClick(scope.row)"
                  v-if="scope.row.clearanceRecordId"
                  >修改</span
                >
                <span class="cell-link" @click="onClick(scope.row)" v-else
                  >填写未完成发货说明</span
                >
              </template>
            </el-table-column>
          </template>
        </customize-table>
      </div>
    </div>
    <InstructionsDialog
      :show.sync="showVisible"
      :selectData="selectData"
      @success="onSuccess"
    />
  </div>
</template>
<script>
import { daterange, openNewPage } from '@/utils/constantime'
import InstructionsDialog from './instructionsDialog'
export default {
  components: {
    InstructionsDialog
  },
  data() {
    return {
      selectData: {},
      showVisible: false,
      removeV: 1,
      pageNum: 1,
      pageSize: 10,
      flag: false,
      selectedDemand: [],
      params: {
        pageIndex: 1,
        pageSize: 10
      },
      formConfig: {
        configs: {
          noticeCode: {
            tag: 'input',

            label: '公告编号'
          },
          noticeTitle: {
            tag: 'input',
            label: '公告标题'
          },
          statusCode: {
            tag: 'select',
            label: '状态',
            options: [
              { value: 0, label: '待执行' },
              { value: 1, label: '执行中' }
            ]
          },
          buyerCompName: {
            tag: 'input',
            label: '买受人'
          },
          clearanceEndTime: {
            ...daterange,
            label: '清运截止日期'
          }
        },
        operations: [
          {
            label: '查询',
            handler: 'on-query',
            type: 'primary'
          },
          {
            label: '清空',
            handler: 'on-reset',
            type: 'default'
          }
        ]
      },
      tableConfig: {
        isPagination: true,
        columns: [
          {
            label: '序号',
            type: 'index',
            width: '50px',
            align: 'center'
          },
          {
            prop: 'noticeCode',
            'show-overflow-tooltip': true,
            label: '公告编号',
            align: 'center',
            width: '120px'
          },
          {
            slot: 'noticeTitle',
            prop: 'noticeTitle',
            label: '公告标题',
            'show-overflow-tooltip': true,
            width: '130px'
          },
          {
            prop: 'dealTime',
            label: '成交日期',
            align: 'center',
            width: '140px'
          },
          {
            prop: 'clearanceEndTime',
            label: '清运截止日期',
            align: 'center',
            width: '140px'
          },
          {
            prop: 'dealPrice',
            label: '成交价',
            align: 'center',
            width: '140px'
          },
          {
            prop: 'dealTotalPrice',
            label: '成交金额',
            align: 'center',
            width: '140px'
          },

          {
            prop: 'buyerCompName',
            label: '买受人',
            align: 'center',
            width: '140px',
            'show-overflow-tooltip': true
          },
          {
            slot: 'statusCode',
            prop: 'statusCode',
            label: '状态',
            align: 'center',
            width: '140px'
          },
          {
            slot: 'controls',
            label: '操作',
            align: 'center',
            width: '200px'
          }
        ],
        data: [],
        total: 0
      },
      choose: ''
    }
  },
  created() {
    this.listNotice()
  },
  methods: {
    async listNotice() {
      let obj = {
        ...this.params
      }
      let data = await this.$api.materialdisposal.listOrder(obj)
      this.tableConfig.data = data.data
      this.tableConfig.total = data.total
    },
    onCurrentChange(val) {
      this.params = {
        ...this.params,
        pageIndex: val,
        pageSize: 10
      }
      this.listNotice()
    },
    onSizeChange(val) {
      this.params = {
        ...this.params,
        pageIndex: 1,
        pageSize: val
      }
      this.listNotice()
    },
    onSuccess(val) {
      if (val) {
        this.listNotice()
      }
    },
    onQuery(val) {
      this.params = {
        pageIndex: this.pageNum,
        pageSize: this.pageSize,
        noticeCode: val.noticeCode ? val.noticeCode : null,
        noticeTitle: val.noticeTitle ? val.noticeTitle : null,
        buyerCompName: val.buyerCompName ? val.buyerCompName : null,
        statusCode: val.statusCode,
        clearanceEndTimeStart:
          val.clearanceEndTime && val.clearanceEndTime.length != 0
            ? val.clearanceEndTime[0]
            : null,
        clearanceEndTimeEnd:
          val.clearanceEndTime && val.clearanceEndTime.length != 0
            ? val.clearanceEndTime[1]
            : null
      }
      this.listNotice()
    },
    onReset(val) {
      console.log(val)
      this.params = {
        pageIndex: this.pageNum,
        pageSize: this.pageSize
      }
      this.listNotice()
    },
    onClick(row) {
      this.selectData = row
      this.showVisible = true
    },
    onCheckBidFile(noticeId) {
      let query = {
        id: noticeId
      }
      openNewPage('CompileMaterialcheck', query)
    }
  }
}
</script>
